var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{attrs:{"type":"border-card"}},[_c('el-tab-pane',{attrs:{"label":"门店管理"}},[_c('companyList')],1),_c('el-tab-pane',{attrs:{"label":"待审核门店"}},[_c('companyAuditList')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }